import $ from 'jquery';
import ClipboardJS from 'clipboard';
import 'sharer.js';

const clipBoard = new ClipboardJS('.share-button--copy');
clipBoard.on('success', function (e) {
    const $this = $(e.trigger);

    $this.addClass('share-button--copy-success');

    setTimeout(function () {
        $this.removeClass('share-button--copy-success');
    }, 3000);
});

$('.share-button--toggle').on('click', function () {
    const $this = $(this);

    $this
        .parent()
        .find('.share-buttons__more')
        .toggleClass('share-buttons__more--active');

    $this
        .find('.share-button__toggle-icon')
        .toggleClass('gral-icons-share gral-icons-close');
});
